/** Approved WRMM-281 hold: an emulated Windows agent is migrated only by explicit reinstall. */
export const WINDOWS_ARM_REINSTALL = 'Reinstall the native ARM64 agent';
export const WINDOWS_ARM_REINSTALL_CODE = 'windows_arm_reinstall_required';
export function windowsArmReinstallRequired(os: string | null, facts: unknown): boolean {
  const f = facts as { os?: { nativeArchitecture?: string }; agent?: { architecture?: string } } | null;
  // Legacy OS bitness is not native-architecture evidence; unknown hosts keep their existing behavior.
  return os === 'windows' && f?.os?.nativeArchitecture === 'arm64' && (f.agent?.architecture ?? 'x64') === 'x64';
}
